<template>
  <el-row class="early-bird-enrollment" :gutter="18">
    <el-col :span="22" :offset="1">
      <el-form ref="enrollment" :model="form" :rules="rules">
        <h4 class="text-uppercased">Complete Enrollment</h4>
        <p>The client is eligible for the Earl Bird Program. Answer the following questions to complete the enrollment.</p>
        <el-form-item prop="hasBeenEfiled">
          <template slot="label">
            Has tax return been signed and (upon receiving the W-2) ready to be transmitted to the IRS?
          </template>
          <el-radio-group v-model="hasBeenEfiled">
            <el-radio :label="true">Yes</el-radio>
            <el-radio :label="false">No</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Is Schedule-C income greater than total W-2 income?" prop="hasCorrectEbAmount">
          <template slot="label">
            Have you verified that the Early Bird Advance field on Client Data contains the correct EB amount?
          </template>
          <el-radio-group v-model="hasCorrectEbAmount">
            <el-radio :label="true">Yes</el-radio>
            <el-radio :label="false">No</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="How would the client like to redeem their coupon?" prop="typeId" v-if="false">
          <el-select v-model="enrollmentVm.typeId" placeholder="Select" filterable no-match-text=" ">
            <el-option v-for="item in allEarlyBirdEnrollmentTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-col :span="22" :offset="1" class="align-center">
        <el-button type="primary" icon="el-icon-success" class="submit_btn" @click="enrollClicked" :loading="isLoading">Enroll Client</el-button>
      </el-col>
    </el-col>
    <el-dialog title="Supervisor Approval" :visible.sync="supervisorSignInVisible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" width="30%">
      <supervisor-approval-dialog :callback="handleSupervisorApproval" @close="supervisorSignInVisible = false"></supervisor-approval-dialog>
    </el-dialog>
  </el-row>
</template>

<script>
import get from 'lodash/get';
import { mapActions, mapGetters } from 'vuex';
import SupervisorApprovalDialog from '@/components/dialog-content/SupervisorApproval.vue';
import { Required, BooleanTrueValidator } from '@/util/formValidators';
import { EarlyBirdEnrollment } from '@/model';

export default {
  name: 'eb-enroll',
  data() {
    return {
      isLoading: false,
      enrollmentVm: new EarlyBirdEnrollment(),
      supervisorSignInVisible: false,
      hasBeenEfiled: undefined,
      hasCorrectEbAmount: undefined,
      rules: {
        hasBeenEfiled: [
          { type: 'boolean', ...Required },
          { validator: BooleanTrueValidator, message: 'Please e-file the tax return.', trigger: 'change' },
        ],
        hasCorrectEbAmount: [
          { type: 'boolean', ...Required },
          { validator: BooleanTrueValidator, message: 'Client will be declined for the Early Bird Advance if the correct EB amount is not entered.', trigger: 'change' },
        ],
        // typeId: [
        //   { trigger: 'blur', type: 'number', ...Required },
        // ],
      },
    };
  },
  watch: {
    ebEnrollment: {
      immediate: true,
      handler(val) {
        this.enrollmentVm = new EarlyBirdEnrollment(val);
      },
    },
  },
  methods: {
    ...mapActions('Lookup', [
      'getEarlyBirdEnrollmentTypes',
    ]),
    ...mapActions('Client', [
      'setEnrollment',
      'submitEnrollment',
      'submitEnrollmentWithApproval',
    ]),
    ...mapActions('Client', {
      saveApplication: 'save',
    }),
    async save() {
      try {
        await this.$refs.enrollment.validate();
      } catch (e) {
        console.warn('enrollment form validation failed', e);
        return;
      }
      this.isLoading = true;
      try {
        await this.setEnrollment(this.enrollmentVm);
        await this.submitEnrollment();
      } finally {
        this.isLoading = false;
      }
    },
    async enrollClicked() {
      try {
        await this.save();
      } catch (e) {
        if (e && get(e, 'response.status') === 403) {
          this.supervisorSignInVisible = true;
        } else {
          throw new Error(e);
        }
      }
    },
    async handleSupervisorApproval(token) {
      await this.setEnrollment(this.enrollmentVm);
      await this.submitEnrollmentWithApproval(token);
    },
  },
  computed: {
    ...mapGetters('Lookup', [
      'allEarlyBirdEnrollmentTypes',
    ]),
    ...mapGetters('Client', [
      'ebEnrollment',
    ]),
    form() {
      return {
        hasBeenEfiled: this.hasBeenEfiled,
        hasCorrectEbAmount: this.hasCorrectEbAmount,
        typeId: this.enrollmentVm.typeId,
      };
    },
  },
  mounted() {
    this.getEarlyBirdEnrollmentTypes();
  },
  components: {
    SupervisorApprovalDialog,
  },
};

</script>

<style lang="scss">
.early-bird-enrollment {
  .submit_btn {
    font-size: 1.5em;
  }
}
</style>
